export default "__VITE_ASSET__BLSKA1WL__"